import React, { Fragment, useState, useEffect } from "react";
import AdministrationHeader from "../../components/header-components/AdministrationHeader";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro"; // <-- import styles to be used
import "@fortawesome/fontawesome-svg-core/styles.css";
import HierarchyTree from "../../components/form-components/HierarchyTree";
import { useLocation } from "react-router-dom";
import AddComponent from "./AddComponent";
import Modal from "../../components/ui-components/Modal";
import UnassignedServices from "../../components/UnassignedServices";
import { DragDropContext, Droppable } from "@hello-pangea/dnd";
import { useOutletContext} from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL;

const ComponentsMapping = () => {
	const location = useLocation();
	const [mergeFromComponent, setMergeFromComponent] = useState({});
	const [mergeToComponent, setMergeToComponent] = useState({});

	const [addComponentWindow, setAddComponentWindow] = useState(false);
	const toggleAddComponentWindow = () =>
		setAddComponentWindow(!addComponentWindow);

	const [mergeComponentWindow, setMergeComponentWindow] = useState(false);
	const toggleMergeComponentWindow = () =>
		setMergeComponentWindow(!mergeComponentWindow);

	const [confirmMergeComponentWindow, setConfirmMergeComponentWindow] =
		useState(false);
	const toggleConfirmMergeComponentWindow = () =>
		setConfirmMergeComponentWindow(!confirmMergeComponentWindow);

	const [removeComponentWindow, setRemoveComponentWindow] = useState(false);
	const toggleRemoveComponentWindow = () =>
		setRemoveComponentWindow(!removeComponentWindow);

	const toggleAlertWindow = () => setAlertWindow(!alertWindow);
	const [alertWindow, setAlertWindow] = useState(false);

	const [hierarchy, setHierarchy] = useState([]);
	const [hierarchyLoaded, setHierarchyLoaded] = useState(false);
	const [unssociatedServices, setUnassociatedServices] = useState([{}]);

	const [componentRequest, setComponentRequest] = useState({
		component: {
			id: -1,
			name: "",
			description: "",
			parent_id: 0,
			tree_order: 0,
			customer_id: 0,
		},
		isLoaded: false,
	});


	const { jwt } = useOutletContext();

	function getRequestOptions() {
		if (jwt === "") return;
		
		const headers = new Headers();
		headers.append("Content-Type", "application/json");
		headers.append("Authorization", "Bearer " + jwt)

		let method = "GET";

		let requestOptions = {
			method: method,
			headers: headers,
		};

		return requestOptions;
	}


	function retrieveHierarchy() {
		if (jwt === "") return;

		fetch(API_URL + "/get-component-hierarchy", getRequestOptions())
			.then((response) => {
				if (response.status !== "200") {
					// let err = Error;
					// err.message = "Invalid response code: " + response.status;
					// setError(err);
				}
				return response.json();
			})
			.then((json) => {
				setHierarchy([json.ComponentHierarchy]);
				setHierarchyLoaded(true);
			});
	}

	useEffect(() => {
		retrieveHierarchy();
		retrieveUnassociatedServices();
	// The fetchers are plain function declarations, so they are re-created on every
	// render; the deps below are the inputs that should actually trigger a refetch.
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [jwt, location]);

	function retrieveComponent(componentID) {
		if (jwt === "") return;

		fetch(API_URL + "/get-component/" + componentID, getRequestOptions())
			.then((response) => {
				if (response.status !== "200") {
					// let err = Error;
					// err.message = "Invalid response code: " + response.status;
					// setError(err);
				}
				return response.json();
			})
			.then((json) => {
				setComponentRequest({
					component: {
						id: json.Component.id,
						name: json.Component.name,
						description: json.Component.description,
						parent_id: json.Component.parent_id,
						tree_order: json.Component.tree_order,
						customer_id: json.Component.customer_id,
					},
					isLoaded: true,
				});
			});
	}

	function mergeComponents(fromID, toID) {
		toggleMergeComponentWindow();

		var fromComponent = findInHierarchy(fromID, hierarchy);

		if (isPartOfHierarchy(toID, fromComponent.children)) {
			toggleAlertWindow();
			return;
		} else {
			setMergeFromComponent(findInHierarchy(fromID, hierarchy));
			setMergeToComponent(findInHierarchy(toID, hierarchy));
			toggleConfirmMergeComponentWindow();
		}
	}

	function confirmMergeComponents() {
		if (jwt === "") return;

		const headers = new Headers();
		headers.append("Content-Type", "application/json");
		headers.append("Authorization", "Bearer " + jwt);

		let method = "PATCH";

		const requestBody = {
			from_id: mergeFromComponent.id,
			to_id: mergeToComponent.id,
		};

		let requestOptions = {
			body: JSON.stringify(requestBody),
			method: method,
			headers: headers,
		};

		fetch(API_URL + "/merge-components", requestOptions)
			.then((response) => {
				if (response.status !== "200") {
					// let err = Error;
					// err.message = "Invalid response code: " + response.status;
					// setError(err);
				}
				return response.json();
			})
			.then((json) => {
				retrieveHierarchy();
				selectNode(mergeToComponent.id.toString());
			});

		toggleConfirmMergeComponentWindow();
	}

	function findInHierarchy(componentID, hierarchy) {
		var result = null;
		for (let i = 0; i < hierarchy.length; i++) {
			if (hierarchy[i].id === componentID) {
				result = hierarchy[i];
			}

			if (hierarchy[i].children !== undefined && result == null) {
				result = findInHierarchy(componentID, hierarchy[i].children);
			}
		}

		return result;
	}

	function findNameInHierarchy(componentName, hierarchy) {
		var result = null;
		for (let i = 0; i < hierarchy.length; i++) {
			if (hierarchy[i].name === componentName) {
				result = hierarchy[i];
			}

			if (hierarchy[i].children !== undefined && result == null) {
				result = findNameInHierarchy(componentName, hierarchy[i].children);
			}
		}

		return result;
	}

	function isPartOfHierarchy(componentID, hierarchy) {
		var result = false;
		for (let i = 0; i < hierarchy.length; i++) {
			if (hierarchy[i].id === componentID) {
				result = true;
			}

			if (hierarchy[i].children !== undefined && result === false) {
				result = isPartOfHierarchy(componentID, hierarchy[i].children);
			}
		}

		return result;
	}

	function removeComponent(componentID) {
		if (jwt === "") return;

		const headers = new Headers();
		headers.append("Content-Type", "application/json");
		headers.append("Authorization", "Bearer " + jwt);

		let method = "PUT";

		const requestBody = {
			id: componentID,
		};

		let requestOptions = {
			body: JSON.stringify(requestBody),
			method: method,
			headers: headers,
		};

		fetch(API_URL + "/remove-component", requestOptions)
			.then((response) => {
				if (response.status !== "200") {
					// let err = Error;
					// err.message = "Invalid response code: " + response.status;
					// setError(err);
				}
				return response.json();
			})
			.then((json) => {
				retrieveHierarchy();
				// selectNode((mergeToComponent.id).toString());
			});

		toggleRemoveComponentWindow();
	}

	function selectNode(componentID) {
		if (componentID !== undefined) {
			if (mergeComponentWindow) {
				mergeComponents(component.id, componentID);
			}
			retrieveComponent(componentID);
		} else {
			setComponentRequest({
				component: {
					...component,
					id: -1,
				},
				isLoaded: false,
			});
		}
	}


	// add a new component
	function saveComponent(name, description, parentID, treeOrder, customerID) {
		if (jwt === "") return;

		const headers = new Headers();
		headers.append("Content-Type", "application/json");
		headers.append("Authorization", "Bearer " + jwt);

		let method = "PUT";

		const requestBody = {
			name: name,
			description: description,
			parent_id: parentID,
			treeOrder: treeOrder,
			customer_id: customerID,
		};

		let requestOptions = {
			body: JSON.stringify(requestBody),
			method: method,
			headers: headers,
		};

		fetch(API_URL + "/add-component", requestOptions)
			.then((response) => {
				if (response.status !== "200") {
					// let err = Error;
					// err.message = "Invalid response code: " + response.status;
					// setError(err);
				}
				return response.json();
			})
			.then((json) => {
				retrieveHierarchy();
				selectNode(json.Component.id.toString());
			});

		toggleAddComponentWindow();
	}


	function updateHierarchy(hierarchy) {
		if (jwt === "") return;

		const headers = new Headers();
		headers.append("Content-Type", "application/json");
		headers.append("Authorization", "Bearer " + jwt);

		let method = "PUT";

		const requestBody = hierarchy;

		let requestOptions = {
			body: JSON.stringify(requestBody),
			method: method,
			headers: headers,
		};

		fetch(API_URL + "/set-component-hierarchy", requestOptions)
			.then((response) => {
				if (response.status !== "200") {
					// let err = Error;
					// err.message = "Invalid response code: " + response.status;
					// setError(err);
				}
				return response.json();
			})
			.then((json) => {
				retrieveHierarchy();
			});
	}

	const wrapperSetHierarchy = (val) => {
		setHierarchy([...val]);
		updateHierarchy(val);
	};

	function retrieveUnassociatedServices() {
		if (jwt === "") return;

		let url = API_URL + "/get-unassociated-services";

		fetch(url, getRequestOptions())
			.then((response) => {
				if (response.status !== "200") {
					let err = Error;
					err.message = "Invalid response code: " + response.status;
					// setError(err);
				}
				return response.json();
			})
			.then((json) => {
				setUnassociatedServices(json.Services);
			});
	}

	const component = componentRequest.component;
	const mergeIcon = icon({ name: "layer-group", style: "solid" });
	const removeIcon = icon({ name: "triangle-exclamation", style: "solid" });


	const handleDragEnd = (result) => {
		const {  destination } = result;
		if (!destination) return;
		let component = findNameInHierarchy(
			result.destination.droppableId,
			hierarchy
		);

		// let sourceElement = determineSource(result.draggableId);

		if (destination.droppableId === "unassignedServices") {
			removeAssociatedComponent(parseInt(result.draggableId));
		} else {
			// let service = findServiceInUnassociatedServices(result.draggableId);
			// console.log(service);
			
			associateComponent(parseInt(result.draggableId), component.id);
		}
	};



	// function determineSource(draggableId) {
	// 	let result = "hierarchy";

	// 	// check if the element is a child of unassignedServices, then it is a service else it is from the hierarchy
	// 	unssociatedServices.forEach((service) => {
	// 		if (service.id === parseInt(draggableId)) {
	// 			result = "unassignedServices";
	// 		}
	// 	});

	// 	return result;
	// }

	// function addServiceToComponentInHierarchy(service, componentID) {
	// 	console.log(service);
	// 	// console.log(hierarchy);

	// 	let component = findInHierarchy(componentID, hierarchy);
	// 	console.log(component);

	// 	component.services.push({
	// 		id: service.id,
	// 		name: service.name,
	// 		description: service.description,
	// 	});

	// 	// let copyHierarchy = hierarchy;
	// 	console.log(hierarchy)
	// }


	function associateComponent(serviceID, componentID) {
		if (jwt === "") return;

		const headers = new Headers();
		headers.append("Content-Type", "application/json");
		headers.append("Authorization", "Bearer " + jwt);

		let method = "PUT";

		const requestBody = {
			service_id: serviceID,
			component_id: componentID,
		};

		let requestOptions = {
			body: JSON.stringify(requestBody),
			method: method,
			headers: headers,
		};

		fetch(API_URL + "/associate-component", requestOptions)
			.then((response) => {
				if (response.status !== "200") {
					// let err = Error;
					// err.message = "Invalid response code: " + response.status;
					// setError(err);
				}
				return response.json();
			})
			.then((json) => {
				retrieveHierarchy();
				retrieveUnassociatedServices();
			});
	}

	function removeAssociatedComponent(serviceID) {
		if (jwt === "") return;
		
		const headers = new Headers();
		headers.append("Content-Type", "application/json");
		headers.append("Authorization", "Bearer " + jwt);

		let method = "PUT";

		const requestBody = {
			service_id: serviceID,
		};

		let requestOptions = {
			body: JSON.stringify(requestBody),
			method: method,
			headers: headers,
		};

		fetch(API_URL + "/remove-associated-component", requestOptions)
			.then((response) => {
				if (response.status !== "200") {
					// let err = Error;
					// err.message = "Invalid response code: " + response.status;
					// setError(err);
				}
				return response.json();
			})
			.then((json) => {
				retrieveHierarchy();
				retrieveUnassociatedServices();
			});
	}

	return (
		<Fragment>
			<AdministrationHeader title="IT Component structure" subTitle="Define the generic IT components that are being used in the organisation" className="text-text-3" />
			<div className="flex flex-1 h-full bg-white">
				<DragDropContext onDragEnd={handleDragEnd}>
					<div className="flex flex-1 flex-col">
						<div className="flex flex-1">
							<div className="h-[calc(100vh-160px)] flex-1 overflow-auto mt-8">
								<HierarchyTree
									treeData={hierarchy}
									isLoaded={hierarchyLoaded}
									selectNode={selectNode}
									updateHierarchy={wrapperSetHierarchy}
									className="z-0"
									selectedKeys={[component.id]}
									mergeMode={mergeComponentWindow}
									draggable={false}
									showServices={true}									
								/>
							</div>
						</div>
					</div>
					<Droppable droppableId="unassignedServices">
						{(provided, snapshot) => (
							<div
								className="flex-none w-[510px] border-l border-border p-10"
								{...provided.droppableProps}
								ref={provided.innerRef}
							>
								<div className="">
									<div className="block mb-2 text-lg font-semibold text-text border-none focus:outline-none w-full">
										Unassigned Services
									</div>
								</div>
								<UnassignedServices 
									data={unssociatedServices} 
									provided={provided}
								/>
							</div>
						)}
					</Droppable>
				</DragDropContext>
				<AddComponent
					show={addComponentWindow}
					close={toggleAddComponentWindow}
					saveComponent={saveComponent}
					parentComponent={component}
				/>
				<Modal
					show={mergeComponentWindow}
					close={toggleMergeComponentWindow}
					title={"Merge component " + component.name}
					description={
						"Select the component to merge " +
						component.name +
						" into. All subcomponents of " +
						component.name +
						" will be moved to the selected component."
					}
					warningMessage=""
					confirmButton=""
					cancelButton="Cancel"
					icon={mergeIcon}
					alertIcon={false}
					modal={false}
				/>
				<Modal
					show={removeComponentWindow}
					close={toggleRemoveComponentWindow}
					title={"Remove component " + component.name}
					description={
						"Are you sure you want to remove component " +
						component.name +
						"? All of the data will be permanently removed."
					}
					warningMessage="This action cannot be undone."
					confirmButton="Remove component"
					cancelButton="Cancel"
					confirmAction={() => removeComponent(component.id)}
					icon={removeIcon}
					alertIcon={true}
					modal={true}
				/>
				<Modal
					show={confirmMergeComponentWindow}
					close={toggleConfirmMergeComponentWindow}
					title={
						"Merge component " +
						mergeFromComponent.name +
						" into component " +
						mergeToComponent.name
					}
					description={
						"Are you sure you want to permanently move all subcomponents of " +
						mergeFromComponent.name +
						" into component " +
						mergeToComponent.name +
						"?"
					}
					warningMessage="This action cannot be undone."
					confirmButton="Merge component"
					cancelButton="Cancel"
					confirmAction={() => confirmMergeComponents(component.id)}
					icon={removeIcon}
					alertIcon={true}
					modal={true}
				/>
				<Modal
					show={alertWindow}
					close={toggleAlertWindow}
					title={"Unable to merge"}
					description={
						"Cannot merge an component into one of its subcomponents."
					}
					warningMessage=""
					confirmButton=""
					cancelButton="Cancel"
					icon={mergeIcon}
					alertIcon={true}
					modal={true}
				/>
			</div>
		</Fragment>
	);
};

export default ComponentsMapping;
